const BytesToMinimumGB = (bytes) => {
  return Math.ceil(bytes / Math.pow(1024, 3)).toFixed(0) * 1;
};

export default BytesToMinimumGB;
